module.exports = __webpack_public_path__ + "static/media/fortis-white.537a02e7.svg";